import { datadogRum } from '@datadog/browser-rum';
import { logger } from 'logger';
import { getDomainEnv, DomainEnv } from 'utils/assets';
import { APP_VERSION } from 'version';
import { AppConfig } from 'types/configs';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LOG = logger.getLogger('useDatadogGlobals');

export function useDatadogGlobals(appConfig?: AppConfig | null) {
  const env = getDomainEnv();
  const prodNonprod = env === DomainEnv.PROD ? env : 'nonprod';
  datadogRum.setGlobalContextProperty('application', 'mml');
  datadogRum.setGlobalContextProperty('env', env);
  datadogRum.setGlobalContextProperty('appconfig_env', prodNonprod);
  datadogRum.setGlobalContextProperty('data_env', appConfig?.gql.host);
  datadogRum.setGlobalContextProperty('tournament_state', appConfig?.gql.static_test_env ?? 'n/a');
  datadogRum.setGlobalContextProperty('team', 'mml-pwa');
  datadogRum.setGlobalContextProperty('platform', 'pwa');
  datadogRum.setGlobalContextProperty('version', APP_VERSION.version);
}
